// Protege a React de extensiones que modifican el DOM (Traductor de Google, etc.) que provocan
// "Failed to execute 'removeChild'/'insertBefore' on 'Node'". Si el nodo ya no es hijo, se ignora en vez de romper la pantalla.
if (typeof Node === "function" && Node.prototype) {
  const origRemove = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      if (process.env.NODE_ENV !== "production") console.warn("domGuard: removeChild ignorado (nodo ajeno)", child);
      return child;
    }
    return origRemove.apply(this, arguments);
  };
  const origInsert = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, refNode) {
    if (refNode && refNode.parentNode !== this) {
      if (process.env.NODE_ENV !== "production") console.warn("domGuard: insertBefore → appendChild (referencia ajena)", refNode);
      return this.appendChild(newNode);
    }
    return origInsert.apply(this, arguments);
  };
}
